export type HeroSlideId = "portugal" | "spain" | "italy" | "greece";

export type HeroSlide = {
  id: HeroSlideId;
  desktop: string;
  mobile: string;
  alt: { pt: string; en: string };
};

/** Static hero slides — WebP photos (see public/hero/ATTRIBUTION.md) */
export const HERO_SLIDES: HeroSlide[] = [
  {
    id: "portugal",
    desktop: "/hero/portugal.webp",
    mobile: "/hero/portugal-mobile.webp",
    alt: {
      pt: "Ribeira do Porto ao entardecer — Portugal, mercado flagship DENVORA Mobility",
      en: "Porto riverside at dusk — Portugal, DENVORA Mobility flagship market",
    },
  },
  {
    id: "spain",
    desktop: "/hero/spain.webp",
    mobile: "/hero/spain-mobile.webp",
    alt: {
      pt: "Barcelona e a costa mediterrânica — Espanha, destinos de residência na Europa",
      en: "Barcelona and the Mediterranean coast — Spain, European residency destinations",
    },
  },
  {
    id: "italy",
    desktop: "/hero/italy.webp",
    mobile: "/hero/italy-mobile.webp",
    alt: {
      pt: "Vernazza, Cinque Terre — Itália, pathways de mobilidade europeia",
      en: "Vernazza, Cinque Terre — Italy, European mobility pathways",
    },
  },
  {
    id: "greece",
    desktop: "/hero/greece.webp",
    mobile: "/hero/greece-mobile.webp",
    alt: {
      pt: "Santorini e o mar Egeu — Grécia, residência e lifestyle na Europa",
      en: "Santorini and the Aegean Sea — Greece, residency and lifestyle in Europe",
    },
  },
];

export const HERO_ROTATION_MS = 7000;

/** LCP preload targets for index.html */
export const HERO_LCP = HERO_SLIDES[0];
